import { useCallback } from 'react'
import { useSnackbar } from 'src/components/snackbar/useSnackbar'

const GLOSSARY_CSV_HEADER =
  'ja(日本語),en(英語),zh-CN(中国語(簡体)),zh-TW(中国語(繁体)),vi(ベトナム語),fil(フィリピノ語(タガログ語)),th(タイ語),pt(ポルトガル語),id(インドネシア語),ne(ネパール語),es(スペイン語),my(ミャンマー語),si(シンハラ語),km(クメール語),bn(ベンガル語)'

const executeSampleCsvDownload = (): void => {
  const csvContent = '\uFEFF' + GLOSSARY_CSV_HEADER + '\n'
  const dataUri =
    'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent)
  const link = document.createElement('a')
  link.href = dataUri
  link.download = '用語集サンプル.csv'
  document.body.appendChild(link)
  try {
    link.click()
  } finally {
    document.body.removeChild(link)
  }
}

export const useDownloadSampleCsv = () => {
  const { showSuccessSnackbar } = useSnackbar()

  return useCallback(() => {
    executeSampleCsvDownload()
    showSuccessSnackbar('CSVファイルをダウンロードしました')
  }, [showSuccessSnackbar])
}
